import React, { FC, useState, useRef } from 'react'
import { isMobile } from 'react-device-detect'

import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import { SectionContainer, VideoSectionVideo, VideoPlayButton } from '../../style/LandingStyle'






interface VideosSectionInterface { }

const VideosSection: FC<VideosSectionInterface> = ({ }) => {

  const videosList = {
    dlaOtylych: {
      video: "https://player.vimeo.com/progressive_redirect/playback/642522673/rendition/540p/540p.mp4?loc=external&oauth2_token_id=1354788489&signature=c36547b020e27e2ffc95d403dac24ee6ae1f4abde2bedae32456d93ffa0f1dd6",
      poster: "https://i.vimeocdn.com/video/1292373951-f7504a4e820c51e07ac1e6dd7e8e14f8181d9236fdff4277a_1920x1080?r=pad"
    },
    mlodszakiZIza: {
      video: "https://player.vimeo.com/progressive_redirect/playback/378376800/rendition/540p/540p.mp4?loc=external&oauth2_token_id=1354788489&signature=a4498ebf0a9d99e67ba9a862f84cf25cbb0a259a4eaad68bc71c321fda03f57a",
      poster: "https://i.vimeocdn.com/video/838118265-c05433fe044db2cac989a8251ad249fec1b8b48036941a1f9f18c539aed00c7c-d_1920x1080?r=pad"
    },
    sredniaki: {
      video: "https://player.vimeo.com/progressive_redirect/playback/378493396/rendition/540p/540p.mp4?loc=external&oauth2_token_id=1354788489&signature=f0a4025906049cb110abc51387444fd440c73ab2f64e187b2366db25d6791de9",
      poster: "https://i.vimeocdn.com/video/838269847-57fd30223a2927d12801b027e9edf2e1c6634dc35268181eaf5a1ad052bc4e54-d_1920x1080?r=pad"
    },
    dance: {
      video: "https://player.vimeo.com/progressive_redirect/playback/463891134/rendition/540p/540p.mp4?loc=external&oauth2_token_id=1354788489&signature=04f76cdd63533c8f5b66193c9611182918fd4fc48d883387fe85d6580dbc7baf",
      poster: "https://i.vimeocdn.com/video/967803764-538fbad04e1d231b76be142ed3df706e2a44580e2a2d108b0deb4bd3f16950fc-d_1920x1080?r=pad"
    },
    pilates: {
      video: "https://player.vimeo.com/progressive_redirect/playback/463583685/rendition/540p/540p.mp4?loc=external&oauth2_token_id=1354788489&signature=c45906b147f00f8d4f050ef171e1d9e1f9eecd011ad004b70e7dfb39ce99de53",
      poster: "https://i.vimeocdn.com/video/967185498-b70ee0f68618a87ee50fa6974ef683a91b98b862ac22b5775ab45e324c5c8ca8-d_1920x1080?r=pad"
    },
    aeroboks: {
      video: "https://player.vimeo.com/progressive_redirect/playback/463456436/rendition/540p/540p.mp4?loc=external&oauth2_token_id=1354788489&signature=2345f4da0a63f441a1cecaf70bd2f33406707c5fcc7aff50d25fa26a4afbb6b6",
      poster: "https://i.vimeocdn.com/video/966867085-1007b16ab2902eb1ebc01c45a926493d810c62d9d8c239da2f929746f7008e01-d_1920x1080?r=pad"
    }
  }

  const [activeButton, setActiveButton] = useState<string>("obesity")
  const [isVideoPlaying, setVideoPlaying] = useState<boolean>(false)
  const [activeVideo, setActiveVideo] = useState(
    videosList["dlaOtylych"]
  )
  const videoRef: any = useRef(null)



  const playVideo = () => {
    videoRef && videoRef.current && videoRef.current.play()
    setVideoPlaying(true)
  }

  const pauseVideo = () => {
    videoRef && videoRef.current && videoRef.current.pause()
    setVideoPlaying(false)
  }

  const switchVideo = (mode: string) => {

    switch (mode) {
      case "obesity":
        setActiveVideo(videosList["dlaOtylych"])
        break;
      case "junior":
        setActiveVideo(videosList["mlodszakiZIza"])
        break;
      case "mid":
        setActiveVideo(videosList["sredniaki"])
        break;
      case "dance":
        setActiveVideo(videosList["dance"])
        break;
      case "pilates":
        setActiveVideo(videosList["pilates"])
        break;
      case "areobox":
        setActiveVideo(videosList["aeroboks"])
        break;
      default:
        break;
    }
  }

  const clickActiveVideo = (mode: string) => {


    switchVideo(mode)
    setActiveButton(mode)
  }

  return (
    <SectionContainer className="video-section" margin={isMobile ? "10% 0 0 0" : "6% 0 0 0"}>
      <GenericRow >
        <GenericTextSpan fWeight="bold" lineHeight="3.5rem" display="block" width="100%" tAlign="center" fSize="3.2rem">

          Przykładowe treningi
        </GenericTextSpan>
      </GenericRow>

      <GenericRow className="landing-videos-section-button-row" wrap={isMobile ? 'wrap' : 'unset'} width={isMobile ? "70%" : "70%"} margin={isMobile ? "5% 0 0 15%" : "5% 0 0 15%"} justify="space-between">
        <GenericButton fWeight={"bold"} justify={"center"} fSize={"0.8rem"} borderRadius={"30px"} width={isMobile ? "100%" : "30%"} onClick={() => clickActiveVideo("obesity")} className={`${activeButton == "obesity" ? "standard" : "promo-outline-btn"} landing-videos-section-button`}>

          <span className="button-span">DLA OTYŁYCH Z JOLĄ </span>
        </GenericButton>
        <GenericButton fWeight={"bold"} justify={"center"} fSize={"0.8rem"} borderRadius={"30px"} width={isMobile ? "100%" : "30%"} onClick={() => clickActiveVideo("junior")} className={`${activeButton == "junior" ? "standard" : "promo-outline-btn"} landing-videos-section-button`} >
          <span className="button-span">MŁODSZAKI Z IZĄ</span>
        </GenericButton>
        <GenericButton fWeight={"bold"} justify={"center"} fSize={"0.8rem"} borderRadius={"30px"} width={isMobile ? "100%" : "30%"} onClick={() => clickActiveVideo("mid")} className={`${activeButton == "mid" ? "standard" : "promo-outline-btn"} landing-videos-section-button`}><span className="button-span">ŚREDNIAKI </span></GenericButton>

      </GenericRow>

      <GenericRow className="landing-videos-section-button-row" wrap={isMobile ? 'wrap' : 'unset'} width={isMobile ? "70%" : "70%"} margin={isMobile ? "1% 0 0 15%" : "1% 0 0 15%"} justify="space-between">
        <GenericButton fWeight={"bold"} justify={"center"} fSize={"0.8rem"} borderRadius={"30px"} width={isMobile ? "100%" : "30%"} onClick={() => clickActiveVideo("dance")} className={`${activeButton == "dance" ? "standard" : "promo-outline-btn"} landing-videos-section-button`}>

          <span className="button-span">DANCE</span>
        </GenericButton>
        <GenericButton fWeight={"bold"} justify={"center"} fSize={"0.8rem"} borderRadius={"30px"} width={isMobile ? "100%" : "30%"} onClick={() => clickActiveVideo("pilates")} className={`${activeButton == "pilates" ? "standard" : "promo-outline-btn"} landing-videos-section-button`} >
          <span className="button-span">PILATES</span>
        </GenericButton>
        <GenericButton fWeight={"bold"} justify={"center"} fSize={"0.8rem"} borderRadius={"30px"} width={isMobile ? "100%" : "30%"} onClick={() => clickActiveVideo("areobox")} className={`${activeButton == "areobox" ? "standard" : "promo-outline-btn"} landing-videos-section-button`}><span className="button-span">AEROBOKS </span></GenericButton>

      </GenericRow>

      <GenericRow className="landing-videos-section-button-row" width={isMobile ? "100%" : "70%"} margin={isMobile ? " 6% 0 0 0" : "3% 0 0 15%"} >
        <VideoSectionVideo playsinline={true}
          playsInline
          webkit-playsinline={true}
          webkit-playsInline onClick={isVideoPlaying && pauseVideo} ref={videoRef} poster={activeVideo.poster} src={activeVideo.video} preload={"auto"} autoBuffer={true} type="video/mp4"  >


        </VideoSectionVideo>
        {!isVideoPlaying && <VideoPlayButton onClick={playVideo} />}
      </GenericRow>

    </SectionContainer>
  )
}

export default VideosSection
